import React from 'react';

import { Box, Col } from '@opendoor/atoms/box';

import type { MegaNavItem } from '../../types';
import { MobileSubMenuBackButton } from './MobileSubMenuBackButton';
import { MobileSubMenuSection } from './MobileSubMenuSection';

interface MobileMenuSubMenuProps {
  megaNavData: MegaNavItem[];
  openSubMenu: string;
  onBack: () => void;
  footer?: React.ReactNode;
}

export const MobileMenuSubMenu: React.FC<MobileMenuSubMenuProps> = ({
  megaNavData,
  openSubMenu,
  onBack,
  footer,
}) => {
  const currentItem = megaNavData.find((item) => item.name === openSubMenu);

  if (!currentItem) return null;

  return (
    <Col className="h-full overflow-x-hidden overflow-y-auto bg-od-bg-primary">
      <Box className="border-t border-od-border-primary" />
      <MobileSubMenuBackButton onClick={onBack} />
      {currentItem.sections?.map((section, sectionIdx) => (
        <MobileSubMenuSection key={sectionIdx} section={section} parentName={openSubMenu} />
      ))}
      {footer}
    </Col>
  );
};
